import React, { useState, useEffect } from 'react';
import { collection, getDocs, orderBy, query } from 'firebase/firestore';
import { db } from '../firebase';

export default function ViewRegistrations() {
  const [registrations, setRegistrations] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchRegistrations();
  }, []);

  const fetchRegistrations = async () => {
    try {
      const q = query(collection(db, 'registrations'), orderBy('createdAt', 'desc'));
      const querySnapshot = await getDocs(q);
      
      const data = [];
      querySnapshot.forEach((doc) => {
        data.push({ id: doc.id, ...doc.data() });
      });
      
      setRegistrations(data);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching registrations:', error);
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="p-8 text-center">Loading...</div>;
  }

  return (
    <div className="p-8">
      <h1 className="text-3xl font-bold mb-6">Registrations</h1>
      <div className="overflow-x-auto">
        <table className="min-w-full bg-white border">
          <thead>
            <tr className="bg-gray-100">
              <th className="px-4 py-2 border">Name</th>
              <th className="px-4 py-2 border">Email</th>
              <th className="px-4 py-2 border">Phone</th>
              <th className="px-4 py-2 border">Payment Status</th>
              <th className="px-4 py-2 border">Reference</th>
              <th className="px-4 py-2 border">Date</th>
            </tr>
          </thead>
          <tbody>
            {registrations.map((reg) => (
              <tr key={reg.id}>
                <td className="px-4 py-2 border">{reg.firstName} {reg.lastName}</td>
                <td className="px-4 py-2 border">{reg.email}</td>
                <td className="px-4 py-2 border">{reg.phoneCode}{reg.phoneNumber}</td>
                <td className="px-4 py-2 border">
                  <span className={`px-2 py-1 rounded ${reg.paymentStatus === 'completed' ? 'bg-green-200' : 'bg-yellow-200'}`}>
                    {reg.paymentStatus}
                  </span>
                </td>
                <td className="px-4 py-2 border text-xs">{reg.paymentReference}</td>
                <td className="px-4 py-2 border text-sm">{new Date(reg.createdAt).toLocaleString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p className="mt-4 text-gray-600">Total: {registrations.length} registrations</p>
    </div>
  );
}